import {
    formatPermissions,
    can as helpCan,
} from '../../../services/auth/permissions'
/**
 * @description
 * Check if user is authenticated with state data (from local storage)
 *
 * @param {@object} state with state data of auth module
 * @return {boolean} true is authenticated, false otherwise
 */
const isAuthenticated = state => !!state.token

const userOfficeID = state => {
    if (!state.user || !state.user.hr_employee) return
    return state.user.hr_employee.g_branch_office_id
}

/**
 * @description
 * Get status of user (success, error or loading)
 *
 * @param {object} state with state data of auth module
 * @return {string}
 */
const authStatus = state => state.status

/**
 * @description
 * Get Cash Desk Workstation ID
 *
 * @param {object} state with state data of auth module
 * @return {int}
 */
const cashDeskWorkstationID = state => state.cash_desk_token

const cashDeskID = state => state.cash_desk_id

const branchOfficeID = state =>
    state.user ? state.user.hr_employee.g_branch_office_id : null
const fullName = e => `${e.names} ${e.last_name1}`
const sellerName = state => (state.seller ? fullName(state.seller.hr_employee) : null)
const userName = state => (state.user ? fullName(state.user.hr_employee) : null)
const userId = state => (state.user ? state.user.id : null)

const can = state => helpCan(formatPermissions(state.permissions))
const branchOfficeName = state =>
    state.user &&
    state.user.hr_employee &&
    state.user.hr_employee.g_branch_office
        ? state.user.hr_employee.g_branch_office.name
        : ''

const branchOfficeAddress = state =>
    state.user &&
    state.user.hr_employee &&
    state.user.hr_employee.g_branch_office
        ? state.user.hr_employee.g_branch_office.address
        : ''

export default {
    isAuthenticated,
    authStatus,
    cashDeskWorkstationID,
    branchOfficeID,
    userName,
    userId,
    cashDeskID,
    can,
    branchOfficeName,
    branchOfficeAddress,
    sellerName,
}
